<template>
  <ul class="thumbnail-grid">
    <li class="browse-control">
      <form :class="{ 'drop-active': $refs.upload && $refs.upload.dropActive, [formClass]: true }">
        <file-upload
          ref="upload"
          v-model="files"
          :post-action="endpoint"
          :headers="headers"
          :data="{ [modelKey]: modelId }"
          :multiple="true"
          @input-file="inputFile"
          @input-filter="inputFilter"
          :disabled="!!disabled"
          :drop="dropEnabled && !disabled"
        >
          <slot>
            <a
              href="javascript:void(0)"
              class="btn btn-lg hide-on-drop"
              :class="['btn btn-block', 'btn-primary', !!disabled ? 'disabled' : '']"
            >
              Browse
              <span class="d-inline d-sm-none">Files</span>
            </a>
            <label></label>
            <div class="show-on-drop text-primary">Drop files here to upload</div>
          </slot>
        </file-upload>
        <span v-if="text" class="text-muted mt-3 d-none d-sm-inline invisible-on-drop">{{ text }}</span>
      </form>
    </li>
    <slot name="uploadItem" :file="file" :i="i" v-for="(file, i) in fileList"> </slot>
  </ul>
</template>

<script>
import FileUpload from 'vue-upload-component'
import { AttachmentApi } from '@/services'
import AuthService from '@/services/AuthService'
import Datepicker from 'vuejs-datepicker'
import Vue from 'vue'
import SecureImg from '@/components/files/SecureImg.vue'

export default {
  props: {
    modelId: {},
    modelKey: { type: String, default: 'referral' },
    attachments: {},
    disabled: {},
    dropEnabled: { type: Boolean, default: true },
    label: {},
    value: { default: () => [], required: false },
    formClass: {
      default: 'dashed-border p-2 p-sm-5 d-flex align-items-center flex-column',
    },
    text: { default: "Click 'Browse' or drop files here to upload" },
  },
  data() {
    return {
      pFiles: [],
      headers: {
        Authorization: 'Token ' + AuthService.token(),
      },
      endpoint: AttachmentApi.endpoint,
      completedUploads: [],
      isSavingDate: false,
    }
  },
  mounted() {},
  computed: {
    fileList() {
      return [...this.uploads].filter((s) => s.id)
    },
    files: {
      get() {
        return this.pFiles || []
      },
      set(files) {
        this.pFiles = files || []
        this.$emit('input', files)
      },
    },
    uploads: {
      get: function () {
        return [
          // {
          //   size: 9044747,
          //   speed: 0,
          //   success: false,
          //   id: '68m0cfgtpco',
          //   name: 'dental-list-refera-122020-linkedin.csv',
          //   progress: '50.00',
          //   active: true,
          // },
          ...this.files.filter((f) => f.active && !(f.success && f.response)),
          ...this.completedUploads,
          ...(this.attachments || []),
        ].filter((f, i, files) => files.findIndex((o) => o.id === f.id) === i && !f.isDeleted)
      },
    },
  },
  components: {
    FileUpload,
    Datepicker,
    SecureImg,
  },
  methods: {
    inputFile: function (newFile, oldFile) {
      if (newFile && !newFile.active) {
        newFile.active = true
        if (newFile && oldFile && newFile.success !== oldFile.success) {
          const payload = {
            referralId: newFile.data.referral,
            attachment: newFile.response,
          }
          try {
            this.$store.dispatch('referrals/attach', payload)
          } catch (e) {
            this.$exception(e)
          }
          this.$emit('uploaded', newFile)
          // this.completedUploads = [newFile.response, ...this.completedUploads]
        }
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/\.(jpeg|jpe|jpg|gif|png|webp|jfif)$/i.test(newFile.name)) {
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
        }
      }
    },
  },
}
</script>
<style scoped lang="scss">
.show-on-drop {
  display: none;
}
.drop-active {
  .hide-on-drop {
    display: none;
  }
  .invisible-on-drop {
    visibility: hidden;
  }
  .show-on-drop {
    display: block;
  }
}
.dashed-border {
  border: 1px dashed var(--border-color);
  border-radius: 5px;
  padding: 2em;
  background-color: #f8f9f9;
  &.drop-active {
    border: 1px dashed var(--primary-color);
    background-color: var(--border-color);
  }
}
.refera-table thead tr th {
  cursor: default;
}
</style>
<style>
/* .file-uploads {
  width: 100%;
}
@media (min-width: 576px) {
  .file-uploads {
    width: auto;
  }
} */
</style>
